import styled from "styled-components";

export const NoResultsMessage = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 3rem;
`;
